<template>
  <Tag
    :value="value"
    :icon="icon"
    :severity="severity"
    :rounded="rounded"
    :class="[baseClass]"
  ></Tag>
</template>

<script>
import Tag from "primevue/tag";
export default {
  components: {
    Tag,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    severity: {
      type: String,
      default: "success",
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    baseClass: {
      type: String,
      default: "",
    },
  },
};
</script>
